module.exports = __webpack_public_path__ + "img/dr.9dcee9d4.svg";